import { Component, OnInit, Input, ViewChildren, QueryList } from '@angular/core';
import { CeRequestOptions } from '../../request-header/request-header.component';
import { FormGroup, FormArray } from '@angular/forms';
import { asEnumerable } from 'linq-es2015';
import { 
  FlatInstructionsFormComponent, 
  SubstrateDisplay, 
  IrrigationDisplay,
  FertigationDisplay,
  FlatTypeDisplay,
  FlatInstructionsOptions,
  FlatInstructionsCopyArgs
   } from './flat-instructions-form/flat-instructions-form.component';

@Component({
  selector: 'app-flat-instructions',
  templateUrl: './flat-instructions.component.html'
})
export class FlatInstructionsComponent implements OnInit {

  @Input() ceRequestOptions: CeRequestOptions;
  @Input() experimentDesignFormGroup: FormGroup;

  public flatInstructionsOptions: FlatInstructionsOptions;

  constructor() {}

  ngOnInit(): void {
    const substrates = asEnumerable(this.ceRequestOptions.substrates)
      .Where(s => s.isActive)
      .OrderBy(s => s.requiresFollowup)
      .ThenBy(s => s.name)
      .Select(s => {
        return <SubstrateDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    const irrigations = asEnumerable(this.ceRequestOptions.irrigations)
      .Where(s => s.isActive)
      .OrderBy(s => s.requiresFollowup)
      .ThenBy(s => s.name)
      .Select(s => {
        return <IrrigationDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    const fertigations = asEnumerable(this.ceRequestOptions.fertigations)
      .Where(s => s.isActive)
      .OrderBy(s => s.requiresFollowup)
      .ThenBy(s => s.name)
      .Select(s => {
        return <FertigationDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    const flatTypes = asEnumerable(this.ceRequestOptions.flatTypes)
      .Where(s => s.isActive)
      .OrderBy(s => s.name)
      .Select(s => {
        return <FlatTypeDisplay>{
          id: s.id,
          display: s.name
        };
      })
      .ToArray();

    this.flatInstructionsOptions = {
      flatTypes: flatTypes,
      substrates: substrates,
      irrigations: irrigations,
      fertigations: fertigations
    };
  }

  public get treatments(): FormArray {
    return <FormArray>this.experimentDesignFormGroup.get("treatments");
  }

  @ViewChildren(FlatInstructionsFormComponent)
  public flatInstructionForms: QueryList<FlatInstructionsFormComponent>;

  public applyAll(sourceComponent: FlatInstructionsFormComponent): void {
    const args: FlatInstructionsCopyArgs = {
      directSeedToPots: sourceComponent.directSeedToPots.value,
      flatType: sourceComponent.flatType.value,
      substrate: sourceComponent.substrate.value,
      irrigation: sourceComponent.irrigation.value,
      fertigation: sourceComponent.fertigation.value
    };

    this.flatInstructionForms.forEach(f => f.copyValueFrom(args));
  }

}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/flat-instructions/flat-instructions.component.ts